import React from "react";

// Cell styles must also work without a surrounding page's stylesheet.
export default function MaturaDataTable({ children, label, minWidth = 280 }) {
  return <div style={{ overflowX: "auto", margin: "18px 0" }}>
    <table aria-label={label} style={{ borderCollapse: "collapse", textAlign: "center", minWidth, margin: "0 auto" }}>
      {React.Children.map(children, group => React.cloneElement(group, {},
        React.Children.map(group.props.children, row => React.cloneElement(row, {},
          React.Children.map(row.props.children, cell => React.cloneElement(cell, {
            style: { border: "1px solid currentColor", padding: "10px 16px", ...(cell.type === "th" ? { background: "rgba(176,154,215,.22)" } : {}) },
          }))
        ))
      ))}
    </table>
  </div>;
}
